import {Axios} from '../axios/axios.js'
//获取人员列表
export const getAdministratorLlist = (e) => {
  return Axios({
    url:"/index.php/Administrator/get_administrator_list",
    method:'put',
    data:e
  })
}

//获取类型下拉列表
export const getTypeList = (e) => {
  return Axios({
    url:"/index.php/Administrator/get_type_list",
    method:'put',
    data:e
  })
}


//获取组织下拉列表
export const getOrganizationList = (e) => {
  return Axios({
    url:'/index.php/Administrator/get_organization_list',
    method:'put',
    data:e
  })
}

//获取门店下拉列表
export const getStoreList = (e) => {
  return Axios({
    url:'/index.php/Administrator/get_store_list',
    method:'put',
    data:e
  })
}

//新增人员
export const addAdministrator = (e) => {
  return Axios({
    url:'/index.php/Administrator/add_administrator',
    method:'put',
    data:e
  })
}

//编辑 人员
export const editAdministrator = (e) => {
  return Axios({
    url:'/index.php/Administrator/edit_administrator',
    method:'put',
    data:e
  })
}

//删除 人员
export const delAdministrator = (e) => {
  return Axios({
    url:'/index.php/Administrator/del_administrator',
    method:'put',
    data:e
  })
}










//获取门店下拉列表
export const editNewOra = (e) => {
  return Axios({
    url:'/index.php/organization/edit_organization',
    method:'put',
    data:e
  })
}

//新建sub store
export const addSubData = (e) => {
  return Axios({
    url:'/index.php/user/add_sub_organization',
    method:'put',
    data:e
  })
}

//删除 sub store
export const deleteSubData = (e) => {
  return Axios({
    url:'/index.php/user/del_sub_organization',
    method:'put',
    data:e
  })
}
//重置店铺密码
export const resetPassword = (e) => {
  return Axios({
    url:'/index.php/user/reset_sub_organization_password',
    method:'put',
    data:e
  })
}
// check username
export const checkUsername = (e) => {
  return Axios({
    url:'/index.php/user/check_sub_organization_name',
    method:'put',
    data:e
  })
}
